<template>
  <div>
    <v-row class="general-indicators__cards mb-0" v-if="canViewAbonentsStatistics">
      <v-col cols="12" md="4">
        <v-card class="statistics-card" flat outlined>
          <v-card-text>
            <div class="statistics-title">Всего аккаунтов</div>
            <div class="statistics-value">
              <v-progress-circular
                v-if="loadingAbonentsStatistics"
                indeterminate
                color="primary"
                size="24"
                class="mr-2"
              ></v-progress-circular>
              <span v-else>{{ formatNumber(abonentsStatistics.abonents_count) }}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="statistics-card" flat outlined>
          <v-card-text>
            <div class="statistics-title">Pro версии</div>
            <div class="statistics-value">
              <v-progress-circular
                v-if="loadingAbonentsStatistics"
                indeterminate
                color="primary"
                size="24"
                class="mr-2"
              ></v-progress-circular>
              <span v-else>{{ formatNumber(abonentsStatistics.pro_versions_count) }}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="statistics-card" flat outlined>
          <v-card-text>
            <div class="statistics-title">Lite версии</div>
            <div class="statistics-value">
              <v-progress-circular
                v-if="loadingAbonentsStatistics"
                indeterminate
                color="primary"
                size="24"
                class="mr-2"
              ></v-progress-circular>
              <span v-else>{{ formatNumber(abonentsStatistics.lite_versions_count) }}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'GeneralIndicatorsOverviewSection',
  props: {
    abonentsStatistics: {
      type: Object,
      required: true,
    },
    loadingAbonentsStatistics: {
      type: Boolean,
      default: false,
    },
    canViewAbonentsStatistics: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatNumber (value) {
      if (value === null || value === undefined) return '0';
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
  },
};
</script>
